import { createStore, applyMiddleware } from 'redux'
import reduxThunk from 'redux-thunk'
import reducers from './reducers'
// import { createLogger } from 'redux-logger'
// const logger = createLogger()
// const store = createStore(reducers, applyMiddleware(reduxThunk, logger))
const store = createStore(reducers, applyMiddleware(reduxThunk))
export default store
